<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <ekatena-form
          @onSubmit="ekatenaFormSubmitHandler"
          :personType="personType"
          :personId="personId" />
      </div>
      <div class="col-md-4">
        <approve-history
            :records.sync="approveRecords"></approve-history>
      </div>
      <div class="col-md-4">
        <pre-approve-history
            :records.sync="preApproveRecords"></pre-approve-history>
      </div>
    </div>


    <approve-model-risk-v2
      v-if="isPreApproveModelRan()"
      class="mt-2"
      @onLoaded="approveLoadedHandler"
      :preApproveRiskModelScore="preApproveRiskModelScore" />

    <vs-divider></vs-divider>

    <pre-approve-risk-model-v2
      class="mt-10"
      ref="preApproveRiskModelComponent"
      @onUpdate="preApproveUpdateHandler"
      @onLoaded="preApproveLoadHelper" />


    <vx-card :title="'Observaciones'" class="w-1/3 mb-32 mt-10 ml-10" v-if="preApproveRiskModelScore">
      <div>
        <vs-list class="text-danger">
          <vs-list-item v-if="64 >= preApproveRiskModelScore.score">
            Solicitar enganche u obligado solidario. En caso que no se vaya a solicitar, dejar registrada la excepción
          </vs-list-item>
          <vs-list-item v-if="65 >= preApproveRiskModelScore.score && 78 <= preApproveRiskModelScore.score">
            Modelo de riesgo indica un rechazo de proyecto, analizar a detalle. En caso que se vaya a dar una pre-
            aprobación, dejar registrada la excepción
          </vs-list-item>
        </vs-list>
      </div>
    </vx-card>
  </div>
</template>

<script>
import PreApproveRiskModelV2 from "@views/admin/RiskModel/Dashboard/RiskModel/PreApproveRiskModelV2";
import ApproveModelRiskV2 from "@views/admin/RiskModel/Dashboard/RiskModel/ApproveModelRiskV2";
import EkatenaForm from "@views/admin/RiskModel/Ekatena/EkatenaForm";
import PreApproveHistory from "@views/admin/RiskModel/Dashboard/RiskModel/PreApproveForm/PreApproveHistory";
import ApproveHistory from "@views/admin/RiskModel/Dashboard/RiskModel/ApproveForm/ApproveHistory";
export default {
  name: "ArcTabV2",
  data: () => ({
    preApproveRiskModelScore: null,
    preApproveRecords: [],
    approveRecords: [],
  }),
  props: {
    personType: {
      type: Number,
      required: true
    },
    personId: {
      type: Number,
      required: true
    }
  },
  components: {ApproveHistory, PreApproveHistory, EkatenaForm, ApproveModelRiskV2, PreApproveRiskModelV2},
  methods: {
    ekatenaFormSubmitHandler() {
      this.$refs.preApproveRiskModelComponent.renderForm();
    },
    preApproveLoadHelper(riskModelResult) {
      this.preApproveRiskModelScore = riskModelResult.current.score;
      this.preApproveRecords = riskModelResult.requests;
    },
    approveLoadedHandler(riskModelResult) {
      this.approveRecords = riskModelResult.requests;
    },
    preApproveUpdateHandler(riskModelResult) {
      this.preApproveRiskModelScore = riskModelResult.score;
      this.preApproveRecords.push(riskModelResult)
    },
    isPreApproveModelRan() {
      return !(this.preApproveRiskModelScore === null || this.preApproveRiskModelScore === undefined)
    }
  }
}
</script>

<style scoped>

</style>
